<template>
  <div class="ls-panel">
    <div class="ls-panel-title" v-if="title">{{ title }}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "LsPanel",
  props: {
    title: String,
    default: ""
  }
}
</script>
<style>
.ls-panel {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 40px;
}

.ls-panel-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/LsPanel.vue